module.exports = __webpack_public_path__ + "static/media/90-45-with-text.e372d496.svg";